var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17,
    viewBox: "0 0 17.5 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_18",
    "data-name": "Gruppe 18",
    transform: "translate(-30.75 -134)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linie_8",
    "data-name": "Linie 8",
    x2: 16,
    transform: "translate(31.5 136.5)",
    fill: "none",
    stroke: "#12a2e8",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_9",
    "data-name": "Linie 9",
    x2: 16,
    transform: "translate(31.5 142.5)",
    fill: "none",
    stroke: "#12a2e8",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_10",
    "data-name": "Linie 10",
    x2: 16,
    transform: "translate(31.5 148.5)",
    fill: "none",
    stroke: "#12a2e8",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    transform: "translate(41 134)",
    fill: "#f2f3f5",
    stroke: "#12a2e8",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    transform: "translate(35 140)",
    fill: "#f2f3f5",
    stroke: "#12a2e8",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    transform: "translate(33 146)",
    fill: "#f2f3f5",
    stroke: "#12a2e8",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 1.75,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.795cfbde51d8bc7785b67f54be5d66e0.svg";
export { ForwardRef as ReactComponent };